export default "__VITE_ASSET__Ho6_eIQE__"